import { BrowserRouter, Route, Routes } from 'react-router-dom';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import AboutUs from './pages/about-us/page';
import Home from './pages/home/page';
import Layout from './pages/Layout';
import ContactUs from './pages/contact-us/page';
import Services from './pages/services/page';
// import ComplaintsAndAppeals from './pages/complaints-and-appeals/page';
import OurSystemPolicy from "./pages/our-system-policy/page";
import OurCommitment from "./pages/our-commitment/page";
import Complaints from "./pages/complaints/page";
import Appeals from "./pages/appeals/page";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path="contact-us" element={<ContactUs />} />
                    <Route path="about-us" element={<AboutUs />} />
                    <Route path="services" element={<Services />} />
                    {/*<Route path="complaints-and-appeals" element={<ComplaintsAndAppeals />} />*/}
                    <Route path="our-system-policy" element={<OurSystemPolicy />} />
                    <Route path="our-commitment" element={<OurCommitment />} />
                    <Route path="complaints" element={<Complaints />} />
                    <Route path="appeals" element={<Appeals />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
